import angular from "angular";
import { vsName as reportingModuleName } from "../../reporting";

import {
  vsLookupManagementServiceName,
  vsLookupManagementServiceProviderName,
} from "./lookupManagement";

import {
  vsServiceName as contractServiceName,
  ContractServiceProvider,
  ContractServiceRun,
} from "./ContractService";
import { configureLookupManagement } from "../../records/lookup/lookupManagement/config";
import { LookupManagementServiceProvider } from "../../records/lookup/lookupManagement";
import {
  vsServiceName as ContractInstanceFieldsServiceName,
  ContractInstanceFieldsService,
} from "./forms/contractInstanceFields";
import {
  SelectContractModalService,
  vsServiceName as selectContractModalServiceName,
  selectContractModalComponentOptions,
  vsComponentName as SelectContractModalComponentOptionsName,
} from "./components/selectContractModal";
import {
  contractInstanceFilesComponentOptions,
  vsComponentName as contractInstanceFilesComponentName,
} from "./components/files";

import {
  contractInstanceFieldsComponentOptions,
  vsComponentName as contractInstanceFieldsComponentName,
} from "./components/fields";
import {
  contractInstanceNotesComponentOptions,
  vsComponentName as contractInstanceNotesComponentName,
} from "./components/notes";
import {
  contractDetailComponentOptions,
  vsComponentName as contractDetailComponentName,
} from "./components/detail";
import {
  changeJournalContractItemViewComponentOptions,
  vsComponentName as changeJournalContractItemViewComponentName,
} from "./changeJournal/contractDetailView";
import { registerRoutes } from "./routes";
import {
  vsComponentName as contractInstanceContactComponentName,
  contractInstanceContactComponentOptions,
} from "./components/contacts/component";
import {
  contractInstanceNumbersComponentOptions,
  vsComponentName as contractInstanceNumbersComponentName,
} from "./components/numbers";

import { vsModuleName as ContractShareConfigModuleName } from "./configs/module";

export const vsModuleName = "SlotTrak.Contract.Shared";

const module = angular
  .module(vsModuleName, [
    reportingModuleName,
    "ui.router",
    ContractShareConfigModuleName,
  ])
  .provider(contractServiceName, ContractServiceProvider)
  //.provider(vsLookupManagementServiceName, LookupManagementServiceProvider)
  .service(ContractInstanceFieldsServiceName, ContractInstanceFieldsService)
  .run(ContractServiceRun)
  .config(registerRoutes)
  .service(selectContractModalServiceName, SelectContractModalService)
  .component(
    SelectContractModalComponentOptionsName,
    selectContractModalComponentOptions
  )
  .component(
    contractInstanceFilesComponentName,
    contractInstanceFilesComponentOptions
  )
  .component(
    contractInstanceFieldsComponentName,
    contractInstanceFieldsComponentOptions
  )
  .component(
    contractInstanceNotesComponentName,
    contractInstanceNotesComponentOptions
  )
  .component(
    contractInstanceContactComponentName,
    contractInstanceContactComponentOptions
  )
  .component(contractDetailComponentName, contractDetailComponentOptions)
  .component(
    changeJournalContractItemViewComponentName,
    changeJournalContractItemViewComponentOptions
  )
  .component(
    contractInstanceNumbersComponentName,
    contractInstanceNumbersComponentOptions
  );
